// eslint-disable-next-line no-shadow
export enum WappRunnerEvent {
  UNMOUNT = 'UNMOUNT',
}

type Listener = (e?: WappRunnerEvent, sessionId?: string) => void

export class Listeners {
  private static listeners: Listener[] = []

  static listen(listener: Listener) {
    Listeners.listeners.push(listener)
    return () => {
      Listeners.listeners = Listeners.listeners.filter(fn => fn !== listener)
    }
  }

  static notify(event: WappRunnerEvent, sessionId: string) {
    Listeners.listeners.forEach(fn => fn(event, sessionId))
  }
}
